import { TListResponse } from 'src/common/types';
import { TTableSort, TTableSortCols } from 'src/components/table/thead/col';

import { adaptUserMetaFromResponse, TUserMeta, TUserMetaResponse } from './user-meta.type';
import { adaptAccountClientSourceFromResponse, TAccountClientSource, TAccountClientSourceResponse } from './account-client-source.type';
import { adaptProductOrderRelationFromResponse, TProductOrderRelation, TProductOrderRelationResponse } from './user-product-order-relation.type';


export const ProductOrderListSortCol = {
	ID: 'id',
	CLIENT: 'client_id',
	TOTAL: 'total',
	CREATED_AT: 'created_at',
};

export type TProductOrderListSortCol = TTableSortCols<typeof ProductOrderListSortCol>;

export type TProductOrderListQuery = {
	limit: number;
	offset: number;
	search?: string;
	sort?: TTableSort;
	sortCol?: TProductOrderListSortCol;
	userNickname?: string;
};

export type TProductOrderListQueryRequest = {
	limit?: number;
	offset?: number;
	search?: string;
	sort?: string;
	sort_col?: string;
	user_nickname?: string;
};

export function adaptProductOrderListQueryToRequest(data?: TProductOrderListQuery): TProductOrderListQueryRequest {
	if (!data) {
		return {};
	}

	const {
		sortCol,
		userNickname,
		...restFields
	} = data;

	return {
		sort_col: sortCol,
		user_nickname: userNickname,
		...restFields
	};
}

export type TProductOrder = {
  id: number;
  total: number;

	client?: TAccountClientSource;
	products: TProductOrderRelation[];
	createdAt: string;
	createdBy: TUserMeta;
};

export type TProductOrderResponse = {
  id: number;
  total: number;

	client?: TAccountClientSourceResponse;
	products: TProductOrderRelationResponse[];
	created_at: string;
	created_by: TUserMetaResponse;
};

export type TProductOrderListResponse = TListResponse<TProductOrderResponse>;

export type TProductOrderList = TListResponse<TProductOrder>;

// export type TProductOrderPayloadRequest = {
//   userNickname: string;
//   productId: string | number;
//   serialNumber: string;
//   name: string;
//   storageId: string;
//   storageName: string;
//   amount: number;
//   amountType: string;
//   amountMultiplicity: number;
//   price: number;
//   isReturnable: boolean;
//   providerId: number;
//   brandId: number;
//   orderAmount: number;
// };

// export type TProductOrderRequest = {
//   user_nickname: string;
//   product_id: string | number;
//   serial_number: string;
//   name: string;
//   storage_id: string;
//   storage_name: string;
//   amount: number;
//   amount_type: string;
//   amount_multiplicity: number;
//   price: number;
//   is_returnable: boolean;
// 	provider_id: number;
//   brand_id: number;
//   order_amount: number;
// };

export function adaptProductOrderFromListResponse(data: TProductOrderListResponse): TProductOrderList {
	const {
		items: itemsRaw = [],
		...restFields
	} = data;

	const items = itemsRaw.map(item => adaptProductOrderFromResponse(item));

	return {
		items,
		...restFields
	};
}

export function adaptProductOrderFromResponse(data: TProductOrderResponse): TProductOrder {
	const {
		id,
		total,
		client: clientRaw,
		products: productsRaw = [],
		created_by: createdByRaw,
		created_at: createdAt,
	} = data;

	const createdBy = adaptUserMetaFromResponse(createdByRaw);
	const products = productsRaw.map(item => adaptProductOrderRelationFromResponse(item));
	const client = clientRaw ? adaptAccountClientSourceFromResponse(clientRaw) : undefined;

	return {
		id,
		total,
		client,
		products,
		createdBy,
		createdAt,
	};
}
